import styles from './ReportNotFound.module.css';
import { assets } from '@round/whitelabel-ui';

const { LogoShort: RoundLogoShort, LinkBroken } = assets;

const ReportNotFound = () => {
    return (
        <>
            <header className={styles.header}>
                <RoundLogoShort className={styles.roundLogo} />
            </header>

            <main className={styles.main}>
                <LinkBroken className={styles.linkIcon} />
                <h1 className={styles.title}>We couldn't find this report</h1>
                <p className={styles.copy}>Please double check the link</p>
            </main>
        </>
    );
};

export default ReportNotFound;
